<template>
  <el-dialog
    title="二级学科管理"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    :close-on-click-modal="false"
    :show-close="false"
    @open="handleOpen"
  >
    <el-row
      :gutter="24"
      class="subject-row"
      v-for="subject in secondSubjects"
      :key="subject.id"
    >
      <el-col :span="24" class="subject-col">
        <span class="subject-title">{{ subject.name }}</span>
        <el-switch
          v-model="subject.enable"
          :active-text="subject.enable ? '已启用' : '未启用'"
          style="margin-left: 20px"
        >
        </el-switch>
      </el-col>
      <el-col :span="24">
        <span class="second">二级学科</span>
        <div class="second-subjects">
          <el-input
            v-for="(item, index) in subject.vos"
            v-model="item.name"
            :key="index + 'subject'"
            :maxlength="10"
            clearable
            @clear="clearInput(index, subject)"
            style="width: 120px; margin: 0 10px 10px 0"
          ></el-input>
          <el-button
            style="width: 80px; height: 36px; line-height: 0"
            @click="addSubject(subject)"
            :disabled="!subject.enable"
            >+ 添加</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="submitting"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
// import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible', 'secondSubjects', 'grade'],
  data () {
    return {
      value: '',
      value2: [
        {
          value: '写字'
        },
        {
          value: '阅读'
        }
      ],
      submitting: false,
      isLastSuccessful: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    }
  },
  mounted () {
  },
  methods: {
    handleOpen () {
      this.submitting = false
    },

    addSubject (subject) {
      if (subject.vos.length === 5) {
        this.$message.error('二级学科最多5个')
        return false
      }
      subject.vos.push(
        {
          name: ''
        }
      )
    },

    clearInput (index, subject) {
      subject.vos.splice(index, 1)
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    submit () {
      this.submitting = true
      let availableSecondSub = _.filter(this.secondSubjects, function (o) { return o.enable && o.vos.length === 0 })
      if (availableSecondSub.length > 0) {
        this.$message.error('二级学科已开启，请设置对应的二级学科')
        this.submitting = false
        return false
      }
      let allSecondSubs = _.filter(_.flatten(_.map(this.secondSubjects, 'vos')), function (o) { return !o.name })
      if (allSecondSubs.length > 0) {
        this.$message.error('二级学科名称不得为空')
        this.submitting = false
        return false
      }
      this.$xhrPost(`/acc/grade/${this.grade}/secondary-subjects`, this.secondSubjects).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.$message.success('操作成功')
          this.closeDialog()
        } else {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  border: none;
}
/deep/ .el-checkbox__input {
  display: none;
}
/deep/ .el-checkbox.is-checked {
  background: #eeeefd;
  color: var(--theme-color);
}
/deep/ .el-checkbox-group {
  display: inline-block;
}
/deep/ .el-checkbox--medium {
  margin: 0 15px 0 0;
}
/deep/ .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
/deep/ .el-dialog__footer {
  text-align: right;
}
.el-switch.is-checked {
  /deep/ .el-switch__core {
    width: 30px;
    height: 12px;
    background: #c6c7f3;
    border: none;
  }
  /deep/ .el-switch__core::after {
    top: -2px;
    right: 0;
    background-color: #5257e9;
  }
}
.el-switch {
  /deep/ .el-switch__core {
    width: 30px;
    height: 10px;
    background: #dcdfe6;
    border: none;
  }
  /deep/ .el-switch__core::after {
    top: -2px;
    left: 0;
  }
}
.subject-row {
  min-height: 108px;
  padding: 20px;
  margin: 0 0 10px 0 !important;
  background: #f9f9f9;
}
.subject-title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #444444;
}
.subject-col {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}
.second {
  line-height: 36px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #757575;
}
.second-subjects {
  margin-left: 20px;
  float: right;
  width: calc(100% - 76px);
}
</style>



// WEBPACK FOOTER //
// src/components/common/SecondSubject.vue